<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card no-shadow card-border>
		<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
			<floating-buttons
				:titleHeader="$t('BreakTable.Action')"
				:cancelText="$t('MODULE_PERMISSION.Cancel')"
				:saveText="$t('Save')"
				:disabledSave="!validateForm"
				@save="saveChanges"
				@cancel="$emit('changeActiveTabEmit', 0)"
			/>
		</div>
		<div class="vx-row mb-4">
			<div class="vx-col w-full md:w-1/2">
				<div>
					<!-- NAME -->
					<vs-input
						:label="$t('Name')"
						v-model="indicatorData.name"
						class="w-full"
						name="item-name"
						v-validate="'required'"
					/>
					<span class="text-danger text-sm" v-show="errors.has('item-name')">{{
						errors.first("item-name")
					}}</span>

					<div class="mt-1">
						<vs-input
							label="Url"
							v-model="indicatorData.url"
							class="w-full"
							name="url"
							v-validate="'required|url'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('url')">{{ errors.first("url") }}</span>
					</div>
				</div>
			</div>

			<div class="vx-col w-full md:w-1/2">
				<label class="vs-input--label">{{ $t("Description") }}</label>
				<vs-textarea
					v-model="indicatorData.description"
					label=" "
					class="w-full"
					name="item-category"
					v-validate="'required'"
					height="95px"
				/>
				<span class="text-danger text-sm" v-show="errors.has('item-category')">{{
					errors.first("item-category")
				}}</span>
			</div>
		</div>

		<assigned-teams-list
			:teamListIds="indicatorData.team_id ? [indicatorData.team_id] : []"
			:customConfig="teamListConfig"
			:componentParent="'INDICATOR'"
		>
			<template slot="alert-message">
				<p v-if="showAlertMissingGroup && assignedTeams.length === 0" class="mt-base">
					<vs-alert
						:active.sync="activeAlertMissingGroup"
						icon-pack="feather"
						icon="icon-info"
						color="warning"
						:title="$t('AssignedTeams.AssignedTeamRequired')"
					>
						{{ $t("AssignedTeams.ClickOnButton") }} + {{ $t("To") }}
						{{ $t("AssignedTeams.AssignedTeamToltip") }}
					</vs-alert>
				</p>
			</template>
		</assigned-teams-list>
	</vx-card>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
// Store
import moduleIndicator from "@/store/indicator/moduleIndicator.js";
// Models
import Indicator from "@/models/Indicator.js";
// Components
import AssignedTeamsList from "@/components/teams/AssignedTeamsList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";

export default {
	components: {
		vSelect,
		flatPickr,
		VuePerfectScrollbar,
		AssignedTeamsList,
		FloatingButtons,
	},
	props: {
		data: {
			type: Indicator,
			default: () => new Indicator(),
		},
	},
	data() {
		return {
			indicatorData: new Indicator(JSON.parse(JSON.stringify(this.data))),
			activeItem: 0,
			update: false,
			resourceMounted: false,
			groupMounted: false,
			resource_id: [],
			group_id: [],
			checkedResources: [],
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			// Style loading
			backgroundLoading: "primary",
			colorLoading: "#fff",
			relatedIds: [],
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
				dateFormat: "H:i:s",
				time_24hr: true,
			},
			showAlertMissingGroup: false,
			activeAlertMissingGroup: true,
			teamListConfig: {
				columns: ["id", "name", "description", "action"],
				defaultColumns: ["id", "name", "description", "action"],
				actionDropdown: false,
				btnAssig: true,
				navbarOptions: true,
				multiple: false,
			},
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.indicatorData.name && this.indicatorData.description;
		},
		assignedTeams() {
			return this.$store.state.moduleTeams.assignedTeams;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	methods: {
		saveChanges() {
			let groupsIdChecked = this.assignedTeams.length > 0 ? this.assignedTeams[0].id : 0;
			let groupsNameChecked = this.assignedTeams.length > 0 ? this.assignedTeams[0].name : "";
			this.indicatorData.team_id = groupsIdChecked ? groupsIdChecked : 0;
			this.indicatorData.team_name = groupsNameChecked ? groupsNameChecked : "";
			if (this.indicatorData.team_id === 0) {
				this.showAlertMissingGroup = true;
				return;
			}
			if (this.indicatorData.id > 0) {
				this.updateIndicator();
			} else {
				this.createIndicator();
			}
		},
		scrollHandle(evt) {},
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#button-create-loading",
				scale: 0.45,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#button-create-loading > .con-vs-loading");
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		showPopupGroup(val) {
			this.groupMounted = val;
		},
		initValues() {
			if (this.indicatorData.id) return;
			this.indicatorData = new Indicator({});
		},
		createIndicator() {
			delete this.indicatorData.id;
			this.openLoading();
			this.$store
				.dispatch("moduleIndicator/addIndicatorItem", this.indicatorData)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Indicators.TitleConfirmIndicatorCreate"),
						text: this.$t("Indicators.TextConfirmIndicatorCreate"),
					});
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					this.$vs.notify({
						color: "error",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					this.closeLoading();
					console.error(err);
				});
		},
		updateIndicator() {
			this.openLoading();
			this.$store
				.dispatch("moduleIndicator/updateIndicatorItem", this.indicatorData)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Indicators.TitleConfirmIndicatorUpdate"),
						text: this.$t("Indicators.TextConfirmIndicatorUpdate"),
					});
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					console.error(err);
					this.closeLoading();
					this.$vs.notify({
						color: "error",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
				});
		},
	},
	created() {
		if (!moduleIndicator.isRegistered) {
			this.$store.registerModule("moduleIndicator", moduleIndicator);
			moduleIndicator.isRegistered = true;
		}
	},
	mounted() {
		if (this.indicatorData.id <= 0) {
			this.initValues();
			this.$validator.reset();
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleTeams/CLEAN_ASSIGNED_TEAMS");
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: auto;
	min-height: auto;
	max-height: 310px;
}

.indicator-content-form {
	width: auto;
	height: 350px;

	.indicator-content-form--card {
		height: 100%;
	}
}
</style>
